"use strict";
/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
Object.defineProperty(exports, "__esModule", { value: true });
exports.NetUploadIcon32Regular = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var forwardRef_1 = require("../../helpers/forwardRef");
var BaseIcon_1 = require("../../internal/BaseIcon");
exports.NetUploadIcon32Regular = forwardRef_1.forwardRef('NetUploadIcon32Regular', function (props, ref) {
    return (react_1.default.createElement(BaseIcon_1.BaseIcon, tslib_1.__assign({ ref: ref, viewBoxSize: 32 }, props),
        react_1.default.createElement("path", { d: "M7.664 10.748a1 1 0 0 1-1.328-1.495l7.006-6.229a4 4 0 0 1 5.315 0l7.007 6.229a1 1 0 0 1-1.328 1.495l-7.007-6.229A2.004 2.004 0 0 0 17 4.282V22.5a1 1 0 0 1-2 0V4.282a2.004 2.004 0 0 0-.329.237l-7.007 6.229Z" }),
        react_1.default.createElement("path", { d: "M3.5 28.25a1 1 0 0 1 1-1h23a1 1 0 1 1 0 2h-23a1 1 0 0 1-1-1Z" })));
});
